import * as React from "react";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {toast} from "react-toastify";
import {gql} from "@apollo/client";
import LoadingDialog from "../../components/loadingDialog";
import {mutate} from "../../lib/apollo";
export default function PublisherToggleActive (params: {pub: any, setPub: any, reload: any}) {
    const [loading, setLoading] = React.useState(false);

    const handleClose = (event?: any, reason?: any) => {
        if (reason && reason == "backdropClick")
            return;
        params.setPub(null);
    };

    const handleDelete = async () => {
        setLoading(true);
        const query = gql`
            mutation m($id: Int!, $active: Boolean!) {
                publisherUpdateActive(id: $id, active: $active)
            }
        `;

        const variables = {
            id: params.pub.id,
            active: !params.pub.active,
        }

        const response = await mutate(query, variables);
        if (response && response.publisherUpdateActive) {
            toast.success(<><Box component={"span"}
                                 sx={{fontWeight: "bold"}}>{params.pub.name} ({params.pub.id})</Box> has been updated
                to <Box
                    component={"span"}
                    sx={{fontWeight: "bold"}}>{params.pub.active ? "Inactive" : "Active"}</Box></>);
            handleClose();
            params.reload();
        }
        setLoading(false);

    }

    if (!params.pub) return <> </>;

    return (
        <>

                <Dialog
                    open={!!params.pub}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Confirm"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to set <Box component={"span"}
                                                                  sx={{fontWeight: "bold"}}>{params.pub.name} ({params.pub.id})</Box> to <Box
                            component={"span"}
                            sx={{fontWeight: "bold"}}>{params.pub.active ? "Inactive" : "Active"}</Box>?
                        </DialogContentText>
                    </DialogContent>
                    {loading ? <LoadingDialog/> :
                    <DialogActions>
                        <Button sx={{color: 'red'}} onClick={handleClose}>No</Button>
                        <Button sx={{color: 'green'}} onClick={handleDelete} autoFocus>
                            Yes
                        </Button>
                    </DialogActions>
                    }
                </Dialog>
        </>
    )
}
